<script>
export const colorMap = new Map([
  ['0', '#FFA743'],
  ['1', '#6A35C9'],
  ['2', '#35C087'],
  ['3', '#999999'],
  ['4', '#2D71FB']
])

function getStyle(val) {
  return {
    display: 'inline-block',
    width: '10px',
    height: '10px',
    borderRadius: '2px',
    marginRight: '5px',
    background: colorMap.get(val)
  }
}

export default {
  functional: true,
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  render(h, { props }) {
    const dotStyle = getStyle(props.value)
    return (
      <div style='display: flex;alignItems: center;'>
        <span style={dotStyle}/> { props.row.processStatusName || '' }
      </div>
    )
  }
}
</script>
